module.exports = __webpack_public_path__ + "media/assets_v3/images/buy-ad-image-d99abca76eea43b366da221bc104efc2.jpeg";